import axios from 'axios'
import * as config from '../config'

export const CONFIG_SET_BINDINGTYPES = "CONFIG_SET_BINDINGTYPES";
export const CONFIG_SET_REGIONS = "CONFIG_SET_REGIONS";

export function GetBindingTypes(){
    return (dispatch) =>{
        axios.get(
            config.apiUrl + "/bindingtypes"
        )
        .then((response)=>{
            dispatch({
                type:CONFIG_SET_BINDINGTYPES,
                payload:response.data
            })
        })
    }
}

export function GetRegions(){
    return (dispatch) =>{
        axios.get(
            config.apiUrl + "/regions"
        )
            .then((response)=>{
                dispatch({
                    type:CONFIG_SET_REGIONS,
                    payload:response.data
                })
            })
    }
}


// WEBPACK FOOTER //
// ./src/actions/configActions.js